module.exports = __webpack_public_path__ + "img/Menu-05.0dd16194.png";